import Vue from 'vue';
import { TOGGLE_SELECTION,
    CLEAR_SELECTIONS,
    SET_PURCHASE_TYPE,
    SET_STAKE,
    SET_IS_LOADING,
    SET_PAYOUT,
    SET_IS_PAYOUT_LOCKED,
    TOGGLE_SYSTEM_SELECTED,
    SET_EVENT,
    CLEAR_SELECTED_SYSTEMS,
    SET_ERROR,
    SET_CANDIDATE_SELECTION,
    SET_UNDO_SELECTIONS,
    SET_UNDO_SELECTIONS_TIMER_ID,
    SET_UNDO_SYSTEMS,
    SET_SELECTED_SYSTEMS, SET_UNDO_STAKE} from './mutationTypes';
import StoreUtil from '@store/StoreUtil';
import ILottoBetSlipState from './types';
import LottoEvent from '@core/models/lotto/LottoEvent';

export default {
    [TOGGLE_SELECTION]: StoreUtil.createToggleListElementMutator('selections'),
    [CLEAR_SELECTIONS]: StoreUtil.createClearListMutator('selections'),
    [SET_CANDIDATE_SELECTION]: StoreUtil.createSimpleMutator('candidateSelection'),

    [SET_UNDO_SELECTIONS]: StoreUtil.createSimpleMutator('undoSelections'),
    [SET_UNDO_STAKE]: StoreUtil.createSimpleMutator('undoStake'),
    [SET_UNDO_SYSTEMS]: StoreUtil.createSimpleMutator('undoSelectedSystems'),
    [SET_UNDO_SELECTIONS_TIMER_ID]: StoreUtil.createSimpleMutator('undoSelectionTimerId'),

    [SET_EVENT](state: ILottoBetSlipState, event: LottoEvent) {
        if (!event) {
            return;
        }
        state.event = {
            totalNumbers: event.totalNumbers,
            numbersDrawn: event.numbersDrawn,
            maxBettableNumber: event.odds.length,
            name: event.name,
            code: event.code,
            eventId: event.id,
            lottoId: event.lottoId,
            endBet: event.endBet!,
            eventDate: event.date,
            odds: event.odds,
            rules: event.rules,
        };

    },

    [SET_SELECTED_SYSTEMS]: StoreUtil.createSimpleMutator('selectedSystems'),

    [TOGGLE_SYSTEM_SELECTED]:(state: ILottoBetSlipState, { isSelected, id }: {isSelected: boolean, id: number}) =>
        Vue.set(state.selectedSystems as any, id, !isSelected),
    [CLEAR_SELECTED_SYSTEMS]:(state: ILottoBetSlipState) =>
        state.selectedSystems = {},

    [SET_PURCHASE_TYPE]: StoreUtil.createSimpleMutator('purchaseType'),
    [SET_STAKE]: StoreUtil.createSimpleMutator('stake'),
    [SET_IS_LOADING]: StoreUtil.createSimpleMutator('isLoading'),

    [SET_PAYOUT]: StoreUtil.createSimpleMutator('payout'),
    [SET_IS_PAYOUT_LOCKED]: StoreUtil.createSimpleMutator('isPayoutLocked'),

    [SET_ERROR]: StoreUtil.createSimpleMutator('error'),
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/lotto/betSlip/mutations.ts